import React from 'react';
import Icon from '../../../components/AppIcon';

const FeaturesSection = () => {
  const features = [
    {
      icon: 'BarChart3',
      title: 'Industry Benchmarks',
      description: 'Compare your metrics against industry standards and peer organizations to understand your competitive position.',
      color: 'bg-secondary'
    },
    {
      icon: 'Target',
      title: 'Gap Analysis',
      description: 'Identify specific areas for improvement with detailed gap analysis and prioritized recommendations.',
      color: 'bg-accent'
    },
    {
      icon: 'TrendingUp',
      title: 'ROI Projections',
      description: 'Get realistic return on investment projections based on proven methodologies and client outcomes.',
      color: 'bg-success'
    },
    {
      icon: 'Shield',
      title: 'Risk Assessment',
      description: 'Understand compliance risks and potential penalties to make informed investment decisions.',
      color: 'bg-error'
    },
    {
      icon: 'FileText',
      title: 'Detailed Reports',
      description: 'Receive comprehensive PDF reports with executive summaries and implementation roadmaps.',
      color: 'bg-warning'
    },
    {
      icon: 'Users',
      title: 'Expert Validation',
      description: 'Optional consultation calls to validate assumptions and refine your strategic approach.',
      color: 'bg-primary'
    }
  ];

  return (
    <section className="py-20 lg:py-24 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary rounded-full px-4 py-2 mb-6">
            <Icon name="Zap" size={16} />
            <span className="text-sm font-medium">Advanced Features</span>
          </div>
          <h2 className="text-section-title text-primary mb-6">
            Sophisticated Analysis Tools
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Our calculators go beyond simple cost estimates to provide comprehensive strategic insights 
            that support executive decision-making and business case development.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features?.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-subtle border border-border hover:shadow-elevation hover:-translate-y-1 transition-all duration-300 group"
            >
              <div className={`w-12 h-12 ${feature?.color} rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <Icon name={feature?.icon} size={24} color="white" />
              </div>
              <h3 className="text-lg font-semibold text-primary mb-3">
                {feature?.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {feature?.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="bg-white rounded-2xl p-8 lg:p-12 shadow-subtle border border-border max-w-4xl mx-auto">
            <h3 className="text-2xl font-semibold text-primary mb-4">
              Ready to Calculate Your ROI?
            </h3>
            <p className="text-muted-foreground mb-6 max-w-2xl mx-auto">
              Join hundreds of organizations that have used our calculators to build compelling 
              business cases for their data strategy investments.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Icon name="Clock" size={16} />
                <span>5-10 minutes</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Icon name="Download" size={16} />
                <span>Instant PDF report</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Icon name="Shield" size={16} />
                <span>No commitment required</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;